/* eslint-disable */
import * as Types from './types';

export type MoneyFragment = { __typename?: 'MoneyV2', currencyCode: Types.CurrencyCode, amount: string };

export declare const MoneyFragment: import("graphql").DocumentNode;
export const MoneyFragmentDoc = /*#__PURE__*/ `
    fragment MoneyFragment on MoneyV2 {
  currencyCode
  amount
}
    `;